import React from 'react';
import { Card, Space, Typography, Input, Form } from 'antd';

const { Text } = Typography;
const { TextArea } = Input;

const CampaignRequestorNotes = ({ formValues }) => {
  return (
    <>
      <Card title="CAMPAIGN NOTES">
        <Space direction="vertical" size="small" style={{ width: '100%' }}>
          <Text>Are there any additional details that the Ops Team should know?</Text>
          <Form.Item name="notes">
            <TextArea 
              rows={2} 
              value={formValues.notes}
            />
          </Form.Item>
        </Space>
      </Card>
    </>
  );
};

export default CampaignRequestorNotes;